import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Lightbulb18 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={18}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M9 0.25C5.27208 0.25 2.25 3.27208 2.25 7C2.25 8.45687 2.87318 9.76944 3.72937 10.8182C4.85495 12.197 5.75 13.5841 5.75 15.0813V17C5.75 17.4142 6.08579 17.75 6.5 17.75H11.5C11.9142 17.75 12.25 17.4142 12.25 17V15.0813C12.25 13.5841 13.1451 12.197 14.2706 10.8182C15.1268 9.76944 15.75 8.45687 15.75 7C15.75 3.27208 12.7279 0.25 9 0.25ZM3.75 7C3.75 4.10051 6.10051 1.75 9 1.75C11.8995 1.75 14.25 4.10051 14.25 7C14.25 8.01912 13.8126 9.0074 13.1087 9.86961C12.3271 10.8269 11.5004 11.9588 11.0634 13.25H9.75V9.31071L11.5304 7.53033L10.4697 6.46967L9.00006 7.93934L7.53039 6.46967L6.46973 7.53033L8.25 9.3106V13.25H6.93657C6.49961 11.9588 5.67285 10.8269 4.89133 9.86961C4.18745 9.0074 3.75 8.01912 3.75 7ZM7.23958 14.75C7.27087 15.2482 7.25 15.7511 7.25 16.25H10.75C10.75 15.7511 10.7291 15.2482 10.7604 14.75H7.23958Z'
      fill='currentColor'
    />
  </Svg>
);

Lightbulb18.displayName = 'Lightbulb18';
export default Lightbulb18;
